import PersonaPage from "./PersonaPage";
import { questionsPersonMale } from "./questions";

const faq = [
  {
    q: "Wie schreibt man eine Trauerrede für den Sohn?",
    a: "Nicht mit einem Lebenslauf. Mit einem Bild, das nur Sie kennen. Ein Blick, eine Angewohnheit, ein Satz, den er als Kind erfunden hat. Von dort aus wird eine Rede, die getragen werden kann.",
  },
  {
    q: "Wie kurz darf eine Trauerrede für den Sohn sein?",
    a: "So kurz, wie Sie es aushalten. Eine Rede von einer Minute mit einem einzigen, klaren Bild ist würdiger als zwanzig Minuten allgemeine Worte.",
  },
  {
    q: "Was, wenn ich es an dem Tag nicht sprechen kann?",
    a: "Verständlich. Viele Eltern lassen in solchen Fällen die Rede von einem Geschwister, einer engen Freundin oder einem Trauerredner vortragen. Der Entwurf funktioniert auch aus einem anderen Mund würdig.",
  },
  {
    q: "Sollen wir seinen Vornamen in der Rede verwenden?",
    a: "Ja, in aller Regel. Der Name macht die Rede persönlich — „unser Sohn Lukas“ ist wärmer und würdiger als „das Kind“. Wir setzen den Namen behutsam ein.",
  },
  {
    q: "Wie schnell erhalten wir den Entwurf?",
    a: "Sofort nach Zahlung. Der Entwurf erscheint auf dem Bildschirm, als PDF und zusätzlich per E-Mail — meist in unter zwei Minuten.",
  },
];

const related = [
  { label: "Trauerrede für die Tochter", to: "/trauerrede-tochter" },
  { label: "Trauerrede für den Bruder", to: "/trauerrede-bruder" },
  { label: "Trauerrede schreiben — Anleitung", to: "/trauerrede-schreiben" },
];

export default function TrauerredeSohn() {
  return (
    <PersonaPage
      slug="trauerrede-sohn"
      metaTitle="Trauerrede für den Sohn schreiben — behutsam & würdevoll | Oratiorede"
      metaDescription="Eine persönliche Trauerrede für den Sohn. Aus acht behutsamen Fragen entsteht ein würdevoller Entwurf — auch wenn Worte gerade unmöglich scheinen. Ab 29 €."
      eyebrow="Trauerrede · Sohn"
      headline={
        <>
          Eine Trauerrede für den Sohn.
          <br />
          <span className="italic text-umber">Klein genug, um getragen zu werden.</span>
        </>
      }
      intro="Es gibt keine Rede, die das ausgleichen kann. Aber es gibt eine, die den Raum für einen Moment ruhig macht — mit einem Bild, einem Satz, einem Namen. Wir helfen, einen Rahmen zu finden, in dem sein Name würdevoll ausgesprochen werden darf."
      heroImage="https://images.unsplash.com/photo-1518709594023-6eab9bab7b23?w=1920&q=80"
      heroImageAlt="Ein leises Detail im warmen Morgenlicht — Sinnbild einer Trauerrede für den Sohn"
      questions={questionsPersonMale}
      exampleQuote={
        <>
          „Er hatte diese Art, den Raum vorsichtig zu betreten — als ob er zuerst prüfen wollte,
          ob alle in Ordnung sind. Er hat uns nicht immer erzählt, was ihn beschäftigt. Aber er
          hat oft gefragt, was uns beschäftigt. Und wer einen Moment darüber nachdenkt, versteht,
          was für ein Geschenk das war. So werden wir ihn behalten.“
        </>
      }
      faq={faq}
      related={related}
    />
  );
}
